module.exports = __webpack_public_path__ + "static/image_02_a@2x-719c43a6c7366c153edd5bf469c3537d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/trusona/image_02_a@2x.jpg
// module id = 418
// module chunks = 3627797113349 20562973939449 33019919093843